module.exports = __webpack_public_path__ + "static/iris-a7d3d8232810835b2bc05d229a0303f5.png";